import React, { Component } from 'react'
import { Col, Row, Image, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import BrandLogo from '../navbars/BrandLogo'

class StudentOrganizationNavbar extends Component {
    
    render() {
        
        return (
            <div className="student-organization-navbar py-3" style={{ backgroundColor: '#213046' }}>
                <Container fluid>
                    <Row>
                        {this.props.name == "defaultvideo" || this.props.name == "fdefaultvideo" ? (""):(
                            <Col sm={10}>
                            <BrandLogo fill="#ffffff" width="159.501" />
                        </Col>
                        )}
                        
                        <Col sm={2}>
                            <div className="profile d-flex align-items-center">
                                {/* {this.props.getStudentProfile.profile_pic != "" ? (<Image src={`https://support.rizee.in/files/${this.props.getStudentProfile.profile_pic}`} width="50" height="50" roundedCircle style={{ border: '1px solid #fff',background: '#fff'}} />) : (
                                                <Image src={require('../../../images/businessman.png')} width="50" height="50" roundedCircle style={{ border: '1px solid #fff',background: '#fff'}} />
                                            )} */}
                                <div className="profile-content ml-3">
                                    {this.props.name == "defaultvideo" || this.props.name == "fdefaultvideo" ? (
                                        <React.Fragment>
                                            
                                            <div className="custom-control custom-radio custom-control-inline">
                                                            <input

                                                                type="radio"
                                                                id="customRadioType1"
                                                                value="1"
                                                                name="examtype"
                                                                className="custom-control-input"
                                                                onChange={this.props.handleInputChange}
                                                                
                                                            />
                                                            <label
                                                                className="custom-control-label text-white"
                                                                htmlFor="customRadioType1"
                                                            >
                                                                NEET
              </label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input
                                                                type="radio"
                                                                id="customRadioType2"
                                                                value="2"
                                                                name="examtype"
                                                                className="custom-control-input"
                                                                onChange={this.props.handleInputChange}
                                                                defaultChecked={true}
                                                            />
                                                            <label
                                                                className="custom-control-label text-white"
                                                                htmlFor="customRadioType2"
                                                            >
                                                                JEE
              </label>
                                                        </div>
                                                    
                                        </React.Fragment>

                                    )
                                        : this.props.name == undefined ? (<h4 className="text-white mb-0">Student Profile</h4>)
                                            : (<h4 className="text-white mb-0">{this.props.name}</h4>)}


                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default StudentOrganizationNavbar
